var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsPJft8UBx3ytTaT-J2M3SkOSmYrAWNp_roA&usqp=CAU","max-width":"100px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }